<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb :items="breadcrumb" visible-button />
    </template>
    <v-row class="containerPolicyList">
      <BaseTab
        class="policyList__tab px-0 mx-0"
        :value="currentTab"
        @change="currentTab = $event"
      >
        <v-row>
          <v-col cols="auto" class="policyList__col">
            <v-tab>APÓLICES</v-tab>
          </v-col>
          <v-spacer class="d-none d-sm-flex" />
        </v-row>
        <v-tab-item class="pt-5">
          <PolicyTable />
        </v-tab-item>
        <v-tab-item class="pt-5">
          <InvoiceTable />
        </v-tab-item>
      </BaseTab>
    </v-row>
  </Main>
</template>
<script>
import PolicyTable from "../components/PolicyTable";
export default {
  name: "PolicyList",
  data: () => ({
    breadcrumb: [
      {
        text: "Apólices",
        to: "quotation element"
      }
    ],
    currentTab: 0
  }),
  components: {
    PolicyTable
  },
  computed: {
    firstTab() {
      return this.currentTab == 0;
    }
  },
  mounted() {
    this.currentTab = this.$route.params.currentTab ?? 0;
  }
};
</script>
<style lang="sass">
.containerPolicyList
  width: 100% !important
  margin: 0 auto !important
.policyList__
  &col
    align-self: center
  &tab
    .v-tabs-bar
      height: 50px !important
</style>
